import { Component, Input } from '@angular/core';
import { Road } from 'src/app/modules/route-planner/models/route-signposts-model';

@Component({
    selector: 'aa-raf-base-signpost',
    templateUrl: './aa-raf-base-signpost.component.html',
    styleUrls: ['./aa-raf-base-signpost.component.scss'],
    standalone: false
})
export class AaRafBaseSignpostComponent {

  @Input() road: Array<Road>;

  constructor() { }

  get roads() {
    return this.road;
  }

  trackByFn(index: number): number {
    return index;
  }
}
